const Brands = () => {
  return (
    <div className="pb-20 flex gap-16 flex-wrap justify-center items-center  ">
     <img src="/assets/brands/brand 1.png" alt="rebook" className=" w-24 " />
     <img src="/assets/brands/brand 2.png" alt="rebook" className=" w-36 " />
     <img src="/assets/brands/brand 3.png" alt="rebook" className=" w-24 " />
     <img src="/assets/brands/brand 4.png" alt="rebook" className=" w-24 " />
     <img src="/assets/brands/brand 5.png" alt="rebook" className=" w-24 " />
    </div>
  )
}
export default Brands
